
import { Injectable } from '@angular/core';
import { Contenido } from '../domain/Contenido';
import { Idioma } from '../domain/Idioma';
import { HistoricoLocalizacionContenido } from '../domain/HistoricoLocalizacionContenido';
import { CoincidenciasLocalizacionContenidos } from '../domain/CoincidenciasLocalizacionContenidos';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Encuesta } from '../domain/Encuesta';

export class HojaXLS {
    columnas: any [];
    filas: any[];

    constructor() {
        this.filas = [];
        this.columnas = [];
    }
}

@Injectable()
export class Exportar {

    /**
     * Exporta xls
     * @param filas
     */
    public exportarXLS(hojaXLS: HojaXLS, nombreFichero: string) {
        try {
            this.generarXLS(hojaXLS, nombreFichero);
        } catch (err) {
            console.log(err);
        }
    }

    /**
     * Metodo que genera la hoja para la impresion del excel apartir de una lista de encuestas 
     * @param encuestas
     * @returns lista con objetos encuestas que solo tienen los campos que van a ser impresos en el excel
     */
    public generarHojaEncuestas(encuestas: Encuesta[]): HojaXLS {
        const hoja: HojaXLS = new HojaXLS();
        const encuestasProcesadas = [];


        encuestas.forEach(element => {
            let fecha = new Date(element.fecha);
            const encuesta = {
				'Nombre': element.nombreEncuesta,
                'Pregunta': element.formulacionPregunta,
				'Respuesta': element.formulacionRespuesta,
                'TipoPregunta': element.tipoPregunta,
                'Fecha': fecha.getFullYear() + '-' + ((fecha.getMonth() + 1)) + '-' + fecha.getDate() + ' ' +fecha.getHours() + ':' + fecha.getMinutes()+ ':' + fecha.getSeconds()

            };
            encuestasProcesadas.push(encuesta);
        });
        hoja.filas = encuestasProcesadas;
        hoja.columnas = [ 'Nombre','Pregunta','Respuesta','Tipo Pregunta','Fecha'];
        return hoja;
    }
    
    /**
     * Metodo que genera la hoja para la impresion del excel apartir de una lista de Localizacion en tiempo real
     * @param localizaciones
     * @returns lista con objetos informes que solo tienen los campos que van a ser impresos en el excel
     */
     public generarHojaLocalizaciones(localizaciones: Contenido[]): HojaXLS {
        const hoja: HojaXLS = new HojaXLS();
        const localizacionesProcesadas = [];

        localizaciones.forEach(element => {
            const contenido = {
				'Elemento': element.Titulo,
                'Descripcion': element.Descripcion,
				'Tipologia': element.Tipo,
                'UltimaLocalizacion': this.formatearFecha(element.FechaUltimaLocalizacion),
                'Localizacion': element.Localizacion
                //'FechaAlta': element.FechaAlta ? element.FechaAlta : '',
				//'FechaBaja': element.FechaBaja ? element.FechaBaja : '',
				// 'expirado': element.expirado,

            };
            localizacionesProcesadas.push(contenido);
        });
        hoja.filas = localizacionesProcesadas;
        hoja.columnas = [ 'Elemento','Descripción','Tipología','UltimaLocalizacion','Localizacion'];
        return hoja;
    }

    /**
     * Método para formatear fechas antes de exportar el contenido del informe
     */
    public formatearFecha(fecha){

    let fechaFormateada =
    ("00" + fecha.getUTCDate()).slice(-2) + "/" +
    ("00" + (fecha.getUTCMonth() + 1)).slice(-2) + "/" +
    fecha.getUTCFullYear() + " " +
    ("00" + fecha.getHours()).slice(-2) + ":" +
    ("00" + fecha.getMinutes()).slice(-2);
        
    return fechaFormateada

    }

    /**
     * Metodo que genera la hoja para la impresion del excel apartir de una lista de Historico
     * @param historicos
     * @returns lista con objetos informes que solo tienen los campos que van a ser impresos en el excel
     */
    public generarHojaLocahistoricos(historicos: HistoricoLocalizacionContenido[]): HojaXLS {
            const hoja: HojaXLS = new HojaXLS();
            const historicosProcesadas = [];
            historicos.forEach(element => {
                const HistoricoLocalizacionContenido = {
                    'Elemento': element.Elemento,
                    'descripcion': element.Descripcion,
                    'tipologia': element.Tipologias,
                    'FechaDesde': this.formatearFecha(element.FechaDesde),
                    'FechaHasta': this.formatearFecha(element.FechaHasta),
                    'Ala': element.Ala,
                    'Nivel': element.Nivel,
                    'Seccion': element.Seccion
    
                };
                historicosProcesadas.push(HistoricoLocalizacionContenido);
            });
            hoja.filas = historicosProcesadas;
            
            hoja.columnas = [ 'Elemento','Descripción','Tipología','FechaDesde','FechaHasta','Ala','Nivel','Seccion'];
            return hoja;
    }

    /**
     * Metodo que genera la hoja para la impresion del excel apartir de una lista de coincidencias
     * @param coincidencias
     * @returns lista con objetos informes que solo tienen los campos que van a ser impresos en el excel
     */
     public generarHojaLocacoincidencias(coincidencias: CoincidenciasLocalizacionContenidos[]): HojaXLS {
        const hoja: HojaXLS = new HojaXLS();
        const coincidenciasProcesadas = [];

        coincidencias.forEach(element => {
            const coincidenciasLocalizacionContenidos = {
                'Elemento1': element.Titulo_1,
                'Elemento2': element.Titulo_2,
                'Duracion': element.tiempo_coincidencia + ' minutos',
                'FechaDesde' : this.formatearFecha(element.desde_max),
                'FechaHasta': this.formatearFecha(element.hasta_min),
                'Localizacion': element.Localizacion

            };
            coincidenciasProcesadas.push(coincidenciasLocalizacionContenidos);
        });
        hoja.filas = coincidenciasProcesadas;
        hoja.columnas = [ 'Elemento1', 'Elemento2', 'Duracion', 'FechaDesde' ,'FechaHasta' , 'Localizacion'];
        return hoja;
    }

    /**
     * Metodo que genera la hoja para la impresion del excel apartir de una lista de contenidos
     * @param contenidos
     * @returns lista con objetos contenido que solo tienen los campos que van a ser impresos en el excel
     */
    public generarHojaContenidos(contenidos: Contenido[], idiomaSeleccionado: Idioma): HojaXLS {
        const hoja: HojaXLS = new HojaXLS();
        const contenidosProcesados = [];

        contenidos.forEach(element => {

			let asignaciones = '';
			element.ElementoAsignado.forEach(elemento => {
				if (elemento.Tipo === 'SECCION') {
					asignaciones = asignaciones + ', ' + elemento.ENTIDAD.SECCION.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).Nombre;
				}
				if (elemento.Tipo === 'ALA') {
					asignaciones = asignaciones + ', ' + elemento.ENTIDAD.ALA.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).Nombre;
				}
				if (elemento.Tipo === 'NODO') {
					asignaciones = asignaciones + ', ' + elemento.ENTIDAD.NODO.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).Nombre;
				}
				if (elemento.Tipo === 'ESPACIO') {
					asignaciones = asignaciones + ', ' + elemento.ENTIDAD.ESPACIO.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).Nombre;
				}
			});

            const contenido = {
                'imagen': element.Imagen,
				'titulo': element.ENTIDAD.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).Nombre,
				'label': element.ENTIDAD.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).NombreCorto,
				'codigo': element.IdAlternativo,
				'tipologia': element.TIPOLOGIA_CONTENIDO.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).Nombre,
				'descripcion': element.ENTIDAD.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).Descripcion,
				'detalle': element.ENTIDAD.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).htmlVisualizableDetalle,
				'AudioTexto': element.ENTIDAD.IDIOMAS.find( x => x.IdIdioma === idiomaSeleccionado.ENTIDAD.Id).AudioTexto,
                'FechaAlta': element.FechaAlta ? element.FechaAlta : '',
				'FechaBaja': element.FechaBaja ? element.FechaBaja : '',
				// 'expirado': element.expirado,
				'asignado': asignaciones,
				'ala': element.ALA_PLANO.Nomobre,
				'xy': element.X + ', ' + element.Y,
				'latLon': element.Latitud + ', ' + element.Longitud
            };
            contenidosProcesados.push(contenido);
        });
        hoja.filas = contenidosProcesados;
        hoja.columnas = ['Imagen', 'Título', 'Texto en Plano', 'Código', 'Tipología', 'Descripción', 'Html Detalle', 'Audioguía', 'Alta', 'Baja', 'Asignado a:', 'Situado en:', 'Coordenadas Plano', 'Coordenadas GPS'];
        return hoja;
    }

    /**
     * Metodo que genera la hoja para la impresion del excel apartir de una lista de contenidosExportar del ws 
     * @param contenidos
     * @returns lista con objetos contenido que solo tienen los campos que van a ser impresos en el excel
     */
    public generarHojaContenidosExportar(contenidosExportar: any[]): HojaXLS {
        const hoja: HojaXLS = new HojaXLS();
        const contenidosProcesados = [];

        contenidosExportar.forEach(element => {

            let asignaciones = '';
			element.Asignado.forEach(elemento => {
				asignaciones = asignaciones + ', ' + elemento;
			});

            const contenido = {
                'imagen': element.Imagen,
				'titulo': element.Titulo,
				'label': element.NombreCorto,
				'codigo': element.IdAlternativo,
				'tipologia': element.Tipologia,
				'descripcion': element.Descripcion,
				'detalle': element.htmlVisualizableDetalle,
				'AudioTexto': element.AudioTexto,
                'FechaAlta': element.FechaAlta ? element.FechaAlta : '',
				'FechaBaja': element.FechaBaja ? element.FechaBaja : '',
				// 'expirado': element.expirado,
				'asignado': element.Asignado,
				'ala': element.Situado,
				'xy': element.X + ', ' + element.Y,
				'latLon': element.Latitud + ', ' + element.Longitud
            };
            contenidosProcesados.push(contenido);
        });
        hoja.filas = contenidosProcesados;
        hoja.columnas = ['Imagen', 'Título', 'Texto en Plano', 'Código', 'Tipología', 'Descripción', 'Html Detalle', 'Audioguía', 'Alta', 'Baja', 'Asignado a:', 'Situado en:', 'Coordenadas Plano', 'Coordenadas GPS'];
        return hoja;
    }

    
    /**
     * Metodo privado que genera el excel
     * @param hojaXLS
     */
    private generarXLS(hojaXLS: HojaXLS, nombreFichero: string) {
        let i = 0;
       
        if (!nombreFichero || nombreFichero === '') {
          nombreFichero = 'Hoja.xlsx';
        }
        if (!hojaXLS.filas || hojaXLS.filas.length === 0) {
            console.error('Lista de filas vacia');
        } else{
			const objetoMuestra = hojaXLS.filas[0];
            let query = 'SELECT ';
            Object.keys(objetoMuestra).forEach(function(key, index) {
                let columna = key;
                try {
                    columna = hojaXLS.columnas[i].header;
                    if (!columna) {
                        columna = key;
                    }
                } catch (error) {
                    columna = key;
                }

                query += key + ' as ' + '[' + columna + '], ' ;
                i += 1;
            });

            query = query.substring(0, query.length - 2);
            query +=  " INTO XLSX ('" + nombreFichero + ".xlsx',{headers:true}) FROM ?";
            alasql(query,[hojaXLS.filas]);
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/service/exportar.service.ts